var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col",attrs:{"align-x":"center","gutter":"35"}},[_c('h1',{staticClass:"center"},[_vm._v("註冊個人帳號")]),_c('div',{staticClass:"message center bg-background2 color-text2"},[_c('p',[_vm._v("請至您的信箱查看帳號註冊信 按照信件步驟，完成註冊")])])])
}]

export { render, staticRenderFns }